"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _reactIs = require("react-is");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _useMounted = _interopRequireDefault(require("react-utils/hooks/useMounted"));

var _useUniqueId = _interopRequireDefault(require("react-utils/hooks/useUniqueId"));

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _useControllable3 = _interopRequireDefault(require("../hooks/useControllable"));

var _focusStylesListener = require("../listeners/focusStylesListener");

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _domElement = _interopRequireDefault(require("../utils/propTypes/domElement"));

var _RootNode = require("../utils/RootNode");

var _PlacementConstants = require("./PlacementConstants");

var _UIControlledPopover = _interopRequireDefault(require("./UIControlledPopover"));

var _UITooltipContent = _interopRequireDefault(require("./UITooltipContent"));

var _UITooltipHeader = _interopRequireDefault(require("./UITooltipHeader"));

var _Hover = require("./utils/Hover");

var _ChildrenWrapper = _interopRequireDefault(require("../utils/ChildrenWrapper"));

var USE_CLASSES = {
  default: 'tooltip-default private-tooltip--default',
  danger: 'tooltip-danger private-tooltip--danger',
  longform: 'private-tooltip--longform'
};
/** An array containing every tooltip's handleOpenChange, to allow tooltips to close each other. */

var allTooltipOpeners = [];
/** An empty array to reuse when declaring hooks with no dependencies */

var NO_DEPENDENCIES = [];

var getPopoverUse = function getPopoverUse(use) {
  if (use === 'default') return 'tooltip';
  if (use === 'danger') return 'tooltip-danger';
  return use;
};

var renderTitle = function renderTitle(title, innerClassName, headingText, use) {
  return _react.default.createElement(_UITooltipContent.default, {
    className: (0, _classnames.default)(innerClassName, 'tooltip-inner', {
      'has--vertical-spacing': use === 'longform'
    })
  }, headingText && _react.default.createElement(_UITooltipHeader.default, null, headingText), title);
};

var UITooltip = (0, _memoWithDisplayName.default)('UITooltip', function (props) {
  var _bodyElement = props._bodyElement,
      children = props.children,
      className = props.className,
      Content = props.Content,
      defaultOpen = props.defaultOpen,
      delay = props.delay,
      delayOnHold = props.delayOnHold,
      disabled = props.disabled,
      headingText = props.headingText,
      innerClassName = props.innerClassName,
      maxWidth = props.maxWidth,
      onOpenChange = props.onOpenChange,
      open = props.open,
      style = props.style,
      target = props.target,
      title = props.title,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["_bodyElement", "children", "className", "Content", "defaultOpen", "delay", "delayOnHold", "disabled", "headingText", "innerClassName", "maxWidth", "onOpenChange", "open", "style", "target", "title", "use"]); // The element that the Tether is attached to

  var _useState = (0, _react.useState)(target),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      targetElement = _useState2[0],
      setTargetElement = _useState2[1];

  var _ref = _bodyElement || (0, _RootNode.getDefaultNode)(),
      ownerDocument = _ref.ownerDocument;

  var _useControllable = (0, _useControllable3.default)(open, defaultOpen, onOpenChange),
      _useControllable2 = (0, _slicedToArray2.default)(_useControllable, 2),
      controllableOpen = _useControllable2[0],
      handleOpenChange = _useControllable2[1];

  var computedDisabled = disabled || Content == null && !title;
  var computedOpen = controllableOpen && !computedDisabled && !!targetElement;
  var hasOpenedRef = (0, _react.useRef)(computedOpen);
  hasOpenedRef.current = hasOpenedRef.current || computedOpen;
  var hasOpened = hasOpenedRef.current;
  var tooltipId = (0, _useUniqueId.default)('tooltip-');

  var triggerOpen = function triggerOpen() {
    handleOpenChange((0, _SyntheticEvent.default)(true));
  };
  /** A timeout that will trigger open after `delay` has elapsed */


  var delayTimeoutRef = (0, _react.useRef)(null);
  /** A timeout that will trigger open after `delayOnHold` has elapsed */

  var delayOnHoldTimeoutRef = (0, _react.useRef)(null);
  /** Cancel any pending timeouts */

  var clearHoverTimeouts = function clearHoverTimeouts() {
    clearTimeout(delayTimeoutRef.current);
    delayTimeoutRef.current = null;
    clearTimeout(delayOnHoldTimeoutRef.current);
    delayOnHoldTimeoutRef.current = null;
  };
  /** Ref to the target element (i.e. the child) */


  var childrenWrapperRef = (0, _react.useRef)(null);
  /** Is the keyboard focus within the target or popover element? */

  var hasFocusRef = (0, _react.useRef)(false);
  /** Is the mouse within (or near) the target or popover element? */

  var hasMouseRef = (0, _react.useRef)(false);
  /** Have we been mounted yet? */

  var mountedRef = (0, _useMounted.default)(); // Tasks to perform on mount/unmount

  (0, _react.useEffect)(function () {
    allTooltipOpeners.push(handleOpenChange);
    return function () {
      allTooltipOpeners.splice(allTooltipOpeners.indexOf(handleOpenChange), 1);
      clearHoverTimeouts();
    };
  }, NO_DEPENDENCIES); // eslint-disable-line react-hooks/exhaustive-deps
  // Tasks to perform on open/close

  (0, _react.useEffect)(function () {
    clearHoverTimeouts();

    if (computedOpen) {
      // Tell all other tooltips on the page to close
      allTooltipOpeners.forEach(function (tooltip) {
        if (tooltip === handleOpenChange) return;
        tooltip((0, _SyntheticEvent.default)(false));
      }); // Bind window-level events that can trigger close

      var maybeTriggerClose = function maybeTriggerClose() {
        if (computedOpen && !hasFocusRef.current && !hasMouseRef.current) {
          handleOpenChange((0, _SyntheticEvent.default)(false));
        }
      };

      var handleWindowMouseLeave = function handleWindowMouseLeave() {
        hasMouseRef.current = false;
        maybeTriggerClose();
        clearHoverTimeouts();
      };

      var handleBodyMouseMove = function handleBodyMouseMove(evt) {
        var targetEl = targetElement;
        var tooltipEl = ownerDocument.getElementById(tooltipId);
        if (!targetEl) return;
        var hadMousebefore = hasMouseRef.current;
        var targetArea = targetEl.getBoundingClientRect();
        hasMouseRef.current = tooltipEl ? !(0, _Hover.shouldTooltipClose)(targetArea, tooltipEl.getBoundingClientRect(), evt) : (0, _Hover.isCursorOver)(targetArea, evt);
        if (hadMousebefore) maybeTriggerClose();
      };

      var handleBodyFocus = function handleBodyFocus() {
        var targetEl = targetElement;
        var tooltipEl = ownerDocument.getElementById(tooltipId);
        if (!targetEl) return;
        var activeElement = ownerDocument.activeElement;
        hasFocusRef.current = (0, _focusStylesListener.isPageInKeyboardMode)() && (targetEl.contains(activeElement) || tooltipEl && tooltipEl.contains(activeElement));
        maybeTriggerClose();
      };

      addEventListener('mouseleave', handleWindowMouseLeave);
      ownerDocument.addEventListener('mousemove', handleBodyMouseMove);
      ownerDocument.addEventListener('focus', handleBodyFocus, true);
      return function () {
        removeEventListener('mouseleave', handleWindowMouseLeave);
        ownerDocument.removeEventListener('mousemove', handleBodyMouseMove);
        ownerDocument.removeEventListener('focus', handleBodyFocus, true);
      };
    }

    return undefined;
  }, [computedOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  /** Open on focus if the page is in "keyboard mode" (so, not on click) */

  var handleTargetFocus = (0, _react.useCallback)(function () {
    if ((0, _focusStylesListener.isPageInKeyboardMode)()) triggerOpen();
  }, [NO_DEPENDENCIES]); // eslint-disable-line react-hooks/exhaustive-deps

  /** Open after a delay when the target element is hovered */

  var handleTargetMouseMove = (0, _react.useCallback)(function () {
    clearTimeout(delayOnHoldTimeoutRef.current);
    delayOnHoldTimeoutRef.current = null;
    hasMouseRef.current = true; // Open after `delay` as long as the mouse doesn't leave the target

    if (!delayTimeoutRef.current) {
      delayTimeoutRef.current = setTimeout(triggerOpen, delay);
    } // Open after `delayOnHold` (sooner) if the mouse holds still


    delayOnHoldTimeoutRef.current = setTimeout(triggerOpen, delayOnHold);
  }, [delay, delayOnHold]); // eslint-disable-line react-hooks/exhaustive-deps

  var child = _react.Children.only(children);

  if (process.env.NODE_ENV !== 'production') {
    if ((0, _reactIs.isFragment)(child)) {
      _devLogger.default.warn({
        message: "UITooltip: child element cannot be a React.Fragment, and must support passing event handlers through to a DOM element.",
        key: 'UITooltip: fragment not supported'
      });
    }
  }

  var clonedChild;

  if (!computedDisabled) {
    var childDescribedBy = child.props['aria-describedby'];
    var childOnFocus = child.props.onFocus;
    var childOnMouseMove = child.props.onMouseMove;
    clonedChild = (0, _react.cloneElement)(child, {
      'aria-describedby': computedOpen ? ((childDescribedBy || '') + " " + tooltipId).trim() : childDescribedBy,
      onFocus: computedOpen ? childOnFocus : (0, _Functions.memoizedSequence)(handleTargetFocus, childOnFocus),
      onMouseMove: computedOpen ? childOnMouseMove : (0, _Functions.memoizedSequence)(handleTargetMouseMove, childOnMouseMove),
      onMouseLeave: (0, _Functions.memoizedSequence)(clearHoverTimeouts, child.props.onMouseLeave),
      tabIndex: 0 // #4949

    });
  }

  (0, _react.useEffect)(function () {
    if (controllableOpen) {
      setTargetElement(target || (0, _reactDom.findDOMNode)(childrenWrapperRef.current));
    }
  });
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_ChildrenWrapper.default, {
    ref: childrenWrapperRef
  }, clonedChild || child), hasOpened && _react.default.createElement(_UIControlledPopover.default, Object.assign({}, rest, {
    _bodyElement: _bodyElement,
    animateOnMount: mountedRef.current,
    arrowSize: use === 'longform' ? 'medium' : 'small',
    className: (0, _classnames.default)(className, USE_CLASSES[use], 'tooltip', 'private-tooltip'),
    closeOnTargetLeave: true,
    content: Content == null ? renderTitle(title, innerClassName, headingText, use) : null,
    Content: Content,
    id: tooltipId,
    open: computedOpen,
    style: Object.assign({}, style, {
      maxWidth: maxWidth
    }),
    target: targetElement,
    use: getPopoverUse(use)
  })));
});
UITooltip.propTypes = {
  _bodyElement: _domElement.default,
  autoPlacement: _UIControlledPopover.default.propTypes.autoPlacement,
  children: _propTypes.default.node,
  Content: _UIControlledPopover.default.propTypes.Content,
  defaultOpen: _propTypes.default.bool,
  delay: _propTypes.default.number.isRequired,
  delayOnHold: _propTypes.default.number.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  headingText: _propTypes.default.node,
  innerClassName: _propTypes.default.string,
  maxWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  onClose: _propTypes.default.func,
  onOpenChange: _propTypes.default.func,
  open: _propTypes.default.bool,
  placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS),
  target: _UIControlledPopover.default.propTypes.target,
  title: _propTypes.default.node,
  use: _propTypes.default.oneOf(Object.keys(USE_CLASSES))
};
UITooltip.defaultProps = {
  defaultOpen: false,
  delay: 300,
  delayOnHold: 100,
  disabled: false,
  use: 'default'
};
var _default = UITooltip;
exports.default = _default;
module.exports = exports.default;